import { useQuery } from "react-query";
import { getProducerCodeReportDetails } from "../../../../../actions/CarrierAgreementMgmt/ProducerCodeConfig";

const useGetAllMappedToKeeper = () => {
  return useQuery(
    ["getProducerCodeReport"],
    () => getProducerCodeReportDetails(),
    {
      refetchOnWindowFocus: false,
    }
  );
};
export default useGetAllMappedToKeeper;
